import React from 'react';
import styles from "./Deal.module.css";
import Dealitem from './Dealitem'


const Deallist = ({dealdata}) => {
    return (
        <div className={styles.deal}>
            {
                dealdata.map((item)=><Dealitem key={item.no} item={item} />
                )
            }
        </div>
    );
};

export default Deallist;